import { render, staticRenderFns } from "./RobotCenterDetails.vue?vue&type=template&id=741f60b4&scoped=true&"
import script from "./RobotCenterDetails.vue?vue&type=script&lang=js&"
export * from "./RobotCenterDetails.vue?vue&type=script&lang=js&"
import style0 from "./RobotCenterDetails.vue?vue&type=style&index=0&id=741f60b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f60b4",
  null
  
)

export default component.exports